module.exports = __webpack_public_path__ + "static/media/Visa-Logo.a47a87e0.png";